// extracted by mini-css-extract-plugin
module.exports = {"input-margin":"InputLable_input-margin__1px3C"};